<p-tabs
  scrollable
  value="0"
  class="engagementDash special-investments-tab"
  (onChange)="onTabChange($event)">
  <p-tablist>
    <p-tab value="0">Activity Count</p-tab>
    <p-tab value="1">Customer Acknowledgement Queue</p-tab>
    <p-tab value="2">Findings Document</p-tab>
    <p-tab value="3">Invoice Queue</p-tab>
    <p-tab value="4">Customer Surveys Queue</p-tab>
    <p-tab value="5">RFP Award Letter</p-tab>
    <p-tab value="6">RFP Description</p-tab>
    <p-tab value="7">All Activities</p-tab>
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel value="0">
      @if (isEngagmentCountSelected) {
        <app-activity-count></app-activity-count>
      }
    </p-tabpanel>
    <p-tabpanel value="1">
      <app-customer-acknowledgement-queue></app-customer-acknowledgement-queue>
    </p-tabpanel>
    <p-tabpanel value="2">
      <app-findings-document></app-findings-document>
    </p-tabpanel>
    <p-tabpanel value="3">
      <app-invoice-queue></app-invoice-queue>
    </p-tabpanel>
    <p-tabpanel value="4">
      <app-customer-surveys-queue></app-customer-surveys-queue>
    </p-tabpanel>
    <p-tabpanel value="5">
      <app-rfp-award-letter></app-rfp-award-letter>
    </p-tabpanel>
    <p-tabpanel value="6">
      <app-rfp-description></app-rfp-description>
    </p-tabpanel>
    <p-tabpanel value="7">
      <app-all-activity></app-all-activity>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
